var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.53125V10.0312M13.5 1.53125V10.0312",
    stroke: "#DDDDEE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9162 1.54291H4.0838C3.17286 1.54291 1.96696 1.38549 1.34398 2.22727C1 2.69205 1 3.36459 1 4.70969C1 5.85649 1 6.42989 1.23194 6.91299C1.62807 7.73809 2.51377 8.09651 3.27291 8.48629L6.98131 10.3904C8.46262 11.151 9.20327 11.5313 10 11.5313C10.7967 11.5313 11.5374 11.151 13.0187 10.3904L16.7271 8.48629C17.4862 8.09651 18.3719 7.73809 18.7681 6.91299C19 6.42989 19 5.85649 19 4.70969C19 3.36459 19 2.69205 18.656 2.22727C18.033 1.38549 16.8271 1.54291 15.9162 1.54291Z",
    stroke: "#DDDDEE",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52922 13.1689C9.24779 12.7438 9.60707 12.5312 10 12.5312C10.3929 12.5313 10.7522 12.7438 11.4708 13.1689L12.4708 13.7604C13.2167 14.2017 13.5896 14.4223 13.7948 14.7912C14 15.1602 14 15.6102 14 16.5102V17.5523C14 18.4523 14 18.9023 13.7948 19.2713C13.5896 19.6402 13.2167 19.8608 12.4708 20.3021L11.4708 20.8936C10.7522 21.3187 10.3929 21.5313 10 21.5313C9.60707 21.5313 9.24779 21.3187 8.52922 20.8936L7.52922 20.3021C6.78332 19.8608 6.41037 19.6402 6.20519 19.2713C6 18.9023 6 18.4523 6 17.5523V16.5102C6 15.6102 6 15.1602 6.20519 14.7912C6.41037 14.4223 6.78332 14.2017 7.52922 13.7604L8.52922 13.1689Z",
    stroke: "#DDDDEE",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.47d5f22b4121101bbd84b303896195ac.svg";
export { ForwardRef as ReactComponent };